import textContent from 'react-addons-text-content';

const getKeyFromChildContent = (child) => (textContent(child).trim().substring(0, 9));

export default getKeyFromChildContent;
